export const BusinessLine = Object.freeze({
  Medicaid: 'medicaid',
  Medicare: 'medicare',
});

export default Object.values(BusinessLine);
